import { Checkbox } from "@/components/ui/checkbox";
import type { FilterOptionType } from "../../types/filter-multi.type";

type FilterMultiCheckboxProps = {
  option: FilterOptionType;
  selectedValues: string[];
  handleChange: (value: string, checked: boolean | string) => void;
};

export const FilterMultiItem = ({
  option,
  selectedValues,
  handleChange,
}: FilterMultiCheckboxProps) => {
  return (
    <div key={option.value} className="items-top my-2.5 flex space-x-2">
      <Checkbox
        checked={selectedValues.includes(option.value)}
        onCheckedChange={(checked) => handleChange(option.value, checked)}
        id={option.value}
        className="h-5 w-5 border-brand-grey3 bg-white data-[state=checked]:bg-brand-green-300"
      />
      <div className="grid items-center gap-1 leading-none">
        <label
          htmlFor={option.value}
          className="text-base text-black leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {option.label}
        </label>
        {option.description && (
          <p className="text-muted-foreground text-xs">{option.description}</p>
        )}
      </div>
    </div>
  );
};
